import { JOB_SPEC_FRAGMENT } from 'apps/rfq/gql';
import { Mutation, Query } from 'core';
import gql from 'graphql-tag';

const PRODUCT_QUOTE_FRAGMENT = gql`
  ${JOB_SPEC_FRAGMENT}
  fragment productQuoteFields on ProductQuote {
    id
    finalCost
    currency
    isEstimated
    isInstantQuote
    isVoid
    validUntil
    for {
      ...jobSpecFields
      build {
        file {
          id
          filename
          permalink
        }
      }
    }
    from {
      id
      jobSpec {
        ...jobSpecFields
        build {
          file {
            id
            filename
            permalink
          }
        }
      }
    }
    supplier {
      id
      address {
        id
        country
      }
      companyName
      initiative {
        id
      }
    }

    createdBy {
      id
      address {
        id
      }
      companyName
      initiative {
        id
      }
    }
    createdAt
  }
`;

const SHIPPING_QUOTE_FRAGMENT = gql`
  fragment shippingQuoteFields on ShippingQuote {
    id
    isTaxInclusive
    currency
    cost
    deliveryTime
    discount
    provider
  }
`;

const SHIPMENT_QUOTE_FRAGMENT = gql`
  ${SHIPPING_QUOTE_FRAGMENT}
  ${PRODUCT_QUOTE_FRAGMENT}
  fragment shipmentQuoteFields on ShipmentQuote {
    id
    incoterm
    downPayment
    manufacturingTime
    bufferTime
    totalCost
    notes
    validUntil
    shippingQuote {
      ...shippingQuoteFields
    }
    address {
      id
      country
      company
      address1
      city
    }
    productQuotes {
      ...productQuoteFields
    }
    miscItems {
      id
      name
      cost
      discount
      currency
    }
    orders {
      id
      createdAt
      quote {
        id
        manufacturingTime
        shippingQuote {
          id
          deliveryTime
        }
        bufferTime
      }
    }
    customerSpace {
      id
      spaceType
      content {
        id
        slug
        title
      }
    }
    createdAt
  }
`;

const SHIPMENT_QUOTE_QUERY = gql`
  ${SHIPMENT_QUOTE_FRAGMENT}
  query ShipmentQuoteQuery($id: ID!) {
    shipmentQuote(id: $id) {
      ...shipmentQuoteFields
    }
  }
`;

export class ShipmentQuoteQuery extends Query {
  static conf = {
    GQL: SHIPMENT_QUOTE_QUERY,
    resultPath: 'shipmentQuote',
  };
}

const INTERMEDIATOR_SHIPMENT_QUOTE_QUERY = gql`
  ${SHIPMENT_QUOTE_FRAGMENT}
  query IntermediatorShipmentQuoteQuery($id: ID!) {
    shipmentQuote(id: $id) {
      ...shipmentQuoteFields
      productQuotes {
        cost
      }
      takeRate
    }
  }
`;

export class IntermediatorShipmentQuoteQuery extends Query {
  static conf = {
    GQL: INTERMEDIATOR_SHIPMENT_QUOTE_QUERY,
    resultPath: 'shipmentQuote',
  };
}

const CREATE_CHECKOUT = gql`
  mutation CreateCheckout($createCheckoutInput: CreateCheckoutInput!) {
    createCheckout(createCheckoutInput: $createCheckoutInput)
  }
`;

export class CreateCheckoutMutation extends Mutation {
  static conf = {
    GQL: CREATE_CHECKOUT,
    inputName: ['createCheckoutInput'], // quote
    resultPath: 'createCheckout',
  };
}

const DELETE_SHIPMENT_QUOTE = gql`
  mutation DeleteShipmentQuote($input: DeleteShipmentQuoteInput!) {
    deleteShipmentQuote(input: $input) {
      id
    }
  }
`;

export class DeleteShipmentQuoteMutation extends Mutation {
  static conf = {
    GQL: DELETE_SHIPMENT_QUOTE,
    inputName: ['input'],
    resultPath: 'deleteShipmentQuote',
  };
}
